export class Logger {
  _log: boolean = false;
  _logger: string = '';

  constructor(active: boolean, logger: string) {
    this._log = active;
    this._logger = logger;
  }

  trace(text: any) {
    if (!this._log) return;
      const content = `[${this._logger}] ${text}`;
      console.trace(content);
  }

  info(text: any) {
    if (!this._log) return;
      const content = `[${this._logger}] ${text}`;
      console.log(content);
  }

  error(text: any) {
    if (!this._log) return;
      const content = `[${this._logger}] ${text}`;
      console.error(content);
  }
}

export const VIEWPORTS = ['xs', 'sm', 'md', 'lg'];
export const VerticalPositionTop = 'top';
export const VerticalPositionBottom = 'bottom';

export type CmsButtonLayout =
  | 'default'
  | 'highlight'
  | 'grey'
  | 'white'
  | 'redrat'
  | 'red'
  | 'red-red'
  | 'red-green'
  | 'green'
  | 'custom-color'
  | 'form-submit'

export type CmsNavType = 'header' | 'headerMobile' | 'footer' | 'footerMeta' | 'iconBar' | 'sideBar' | 'tree';

export type AnimationFunctions =
  | 'linear'
  | 'ease'
  | 'ease-in'
  | 'ease-out'
  | 'ease-in-out';

export type AnimationDirection =
  | 'normal'
  | 'reverse';

export type VerticalPosition =
  | 'top'
  | 'bottom';

export type HorizontalPosition =
  | 'left'
  | 'center'
  | 'right';

export type Position =
  | 'top'
  | 'bottom'
  | 'center'
  | 'left'
  | 'right';

export type AnchorType =
  | 'link'
  | 'inpage';

export type TextPosition =
  | 'top'
  | 'center'
  | 'bottom';

export type CmsToggleDetail = {
  index: number;
}

export type BreakpointSpeedConfig = {
  name: string;
  fromWidth: number;
  speedMultiplier: number;
};

export type FormValue = {
  name: string;
  value: any;
}

export type DropdownType =
  | 'list'
  | 'multiselect'
  | 'date';

export type FilterType =
  | 'country';

export type PaginationType =
  | 'dot'
  | 'number';

export type InputFieldType =
  'text'
  | 'password'
  | 'email'
  | 'tel'
  | 'dropdown'
  | 'checkboxes'
  | 'legend'
  | 'label'
  | 'checkbox'
  | 'button'
  | 'submit'
  | 'placeholder'
  | 'link'
  | 'hidden';

export type MediaType =
  'picture'
  | 'video';

export type VideoType =
  'video'
  | 'youtube'
  | 'youku'
  | 'vimeo';

export interface CmsButtonConfig {
  name?: string;
  form?: string;
  label?: string;
  layout?: CmsButtonLayout;
  fontColor?: string; // class: color-light | btn-font-color-light | color-dark | btn-font-color-dark
  icon?: string;
  iconPosition?: HorizontalPosition;
  bgColor?: string;
  width?: string;
  noMargin?: boolean;
}

export interface CmsNavigationEntry {
  id?: string;
  label?: string;
  title?: string;
  description?: string;
  link?: string;
  img?: string;
  icon?: string;
  color?: string;
  children?: CmsNavigationEntry[];
  content?: any;
}

export interface CmsNavigationTrees {
  footer: CmsNavigationEntry[] | null;
  iconBar: CmsNavigationEntry[] | null;
  footerMeta: CmsNavigationEntry[] | null;
}

export interface CmsNavigationConfig {
  jsonUrl: string;
  data: CmsNavigationTrees | null;
  type: CmsNavType;
}

export interface CmsLinkConfig {
  link?: string;
  target: string | '_self';
  label?: string;
  description?: string;
  sectionId?: string;
  gtmId?: string;
  class?: string;
  linkIcon?: string;
  dam: boolean | false;
  selected: boolean | false;
  children?: [];
  button?: CmsButtonConfig;
  image?: CmsImageConfig;
}

export interface CmsIconConfig {
  uid: string,
  icon: string,
  label: string,
  tooltip?: string,
  color: string
}

export interface CmsImageConfig {
  url: string;
  caption: string;
  width: number;
  height: number;
}

export interface YoutubeConfig {
  host: string;
  playerUrl: string;
  previewUrl: string;
}

export interface YoukuConfig {
  host: string;
  playerUrl: string;
  previewUrl: string;
  clientId?: string;
}

export interface Behavior {
  sticky: boolean;
  hideUnderlying: boolean;
  fullVirtualHeight: boolean;
  backgroundColor: string;
  backgroundOpacity: number;
  renderMarginDiv: boolean | false;
  blockmargin: BlockMargin;
  collapsePadding: Padding;
  additionalClasses: string[];
  hideInViewport: Viewport;
}

export interface SectionBehavior {
  sticky: boolean;
  fullVirtualHeight: boolean;
  bgColor: string;
  blockMargin: BlockMargin;
  hostClass: string;
  sectionClass: string;
  sectionStyle: {};
}

export interface Viewport {
  xs: boolean,
  sm: boolean,
  md: boolean,
  lg: boolean
}

export interface BlockMargin {
  top: boolean,
  bottom: boolean
}

export interface Padding {
  top: boolean,
  left: boolean,
  right: boolean,
  bottom: boolean
}

export interface Video {
    webm: string;
    mp4: string;
}

export interface Picture {
  src: string;
  alt: string;
}
